import React from 'react';
import './CompanyNews.scss';
import { companyNew, IndustryNews, policyStudy } from '@/fetch'
class NewsDetail extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      backImages: [
        { imgPath: require("img/back.png"), imgHDPath: `${require("img/back.png")} 1x,${require("img/back@2x.png")} 2x,${require("img/back@3x.png")} 3x` },
      ],
      title: '',
      link: '',
      data: [],
    }
  }
  componentDidMount() {
    const params = this.props.match.params
    switch (params.pageName) {
      case "CompanyNews":
        this.setState({
          title: '公司动态',
          link: '/Introduction/CompanyNews',
        })
        companyNew.getDetails(params.id).then(res => {
          res.data.content = res.data.content.replace(/<video/gi, "<video autoplay='autoplay' controls='controls'")
          this.setState({ data: res.data })
        }).catch(err => console.log(err))
        break;
      case "Policy":
        this.setState({
          title: '青矩洞察',
          link: '/News/Policy',
        })
        policyStudy.getDetails(params.id).then(res => {
          res.data.content = res.data.content.replace(/<video/gi, "<video autoplay='autoplay' controls='controls'")
          this.setState({ data: res.data })
        }).catch(err => console.log(err))
        break;
      case "Industry":
        this.setState({
          title: '热点聚焦',
          link: '/News/Industry',
        })
        IndustryNews.getDetails(params.id).then(res => {
          res.data.content = res.data.content.replace(/<video/gi, "<video autoplay='autoplay' controls='controls'")
          this.setState({ data: res.data })
        }).catch(err => console.log(err))
        break;
      default:
        break;
    }
  }
  back() {
    this.props.history.go(-1)
  }
  render() {
    const { data, title } = this.state;
    console.log(data, 'data');
    return (

      <div className='NewsDetail' >

        <main className='NewsDetail-body'>
          <nav className='del-nav'>
            {
              this.state.backImages.map((item, index) =>
                <img onClick={() => this.back()} key={index} src={item.imgPath} alt="" srcSet={item.imgHDPath} />
              )
            }
            <span>{title}</span>
          </nav>
          <section className='NewsDetail-count'>
            <h4>{data.title}</h4>
            {
              title === "公司动态" ? <p>发布时间：{data.createAt && data.createAt.split(' ')[0]}</p> : ''

            }
            {
              title === "热点聚焦" ? <p>{data.source} | {data.createAt && data.createAt.split(' ')[0]}</p> : ''

            }
            {
              title === "青矩洞察" ? <p>{data.createAt && data.createAt.split(' ')[0]} | {data.source} | {data.author}</p> : ''

            }
            <div className='html-content' dangerouslySetInnerHTML={{ __html: data.content }} />
          </section>
        </main>
      </div>
    )
  }
}
export default NewsDetail;
